export default __webpack_public_path__ + "static/media/vergne18-21.52275747.png";